import { StaticImageData } from 'next/image'
import ShredderIcon from './icon-shredder.svg'
import WandIcon from './icon-wand.svg'
import SparklesIcon from './icon-sparkles.svg'
import CodeIcon from './icon-code.svg'

export type BuilderHeroDataType = {
  icon: StaticImageData
  description: string
}

export const builderHeroData: BuilderHeroDataType[] = [
  {
    icon: ShredderIcon,
    description: 'Extract docs with AI',
  },
  {
    icon: WandIcon,
    description: 'Generate Operations with AI',
  },
  {
    icon: SparklesIcon,
    description: 'Generate Data Collections with AI',
  },
  {
    icon: CodeIcon,
    description: 'AI Integration Code Suggestions',
  },
]
